import { ReactNode } from "react"

import { IReport } from "interfaces/Report";
import { useManualOccurrence } from "contexts/register/ManualOccurrence";
import { AutoComplete } from "components/Autocomplete"

import * as S from './styles'
import NoPolicemanError from "./Tabs/NoPolicemanError";

type TabWithAutoCompleteProps = {
  element: ReactNode
}

export function TabWithAutoComplete({ element }: TabWithAutoCompleteProps) {
  const {
    occurrenceToEdit,
    changeSelectedReport,
    selectedReport
  } = useManualOccurrence();

  const occurrenceHaveReports = occurrenceToEdit.report && occurrenceToEdit.report.length > 0

  if (!occurrenceHaveReports) return (
    <NoPolicemanError />
  )

  return (
    <S.TabWithAutoComplete>
      <div className="auto-complete-container">
        <AutoComplete
          label="Selecione um pronta-resposta"
          placeholder="Selecione ou pesquise por nome..."
          isMulti={false}
          options={occurrenceToEdit.report}
          getOptionLabel={report => report?.superficialPoliceman?.name ?? report.policeman.user.name}
          value={selectedReport}
          onChange={report => changeSelectedReport(report as IReport)}
        />
      </div>
      {element}
    </S.TabWithAutoComplete>
  )
}